import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import { get } from 'lodash';

import { msg } from 'api';
import { catalogueStaticLinks } from 'apps/catalogue/links';

import { links } from '[theme-lib]/links';

import BrowseShop from 'apps/navigation/containers/BrowseShop';
import NavigationMenuContent from 'apps/topNavigation/containers/NavigationMenuContent';
import PrimaryBarDropdown from './PrimaryBarDropdown';
import SeasonalDropdown from './SeasonalDropdown';
import UserAvatar from './UserAvatar';

export default class PrimaryBar extends PureComponent {
  static propTypes = {
    topNavigation: PropTypes.object,
    isLoggedIn: PropTypes.bool.isRequired,
    seasonalEvents: PropTypes.array,
    subscriptionsNavigationEnabled: PropTypes.bool,
    user: PropTypes.object,
  };

  state = {
    userAvatarError: false,
  };

  onUserAvatarError = () => {
    this.setState({
      userAvatarError: true,
    });
  }

  buildAccountSection() {
    return [{ children: this.props.topNavigation.links.account }];
  }

  render() {
    const {
      user,
      isLoggedIn,
      seasonalEvents,
      subscriptionsNavigationEnabled,
    } = this.props;
    const { userAvatarError } = this.state;
    const userImageLink = get(user, 'customerDetails.profilePicture', null);
    const isFbUser = typeof userImageLink === 'string';

    const userAvatarElement = userImageLink && (
      <UserAvatar
        key="userAvatar"
        src={userImageLink}
        alt="customer icon"
        onError={this.onUserAvatarError}
      />
    );

    const contactUs = get(
      this.props.topNavigation,
      'subNavItemsByTabs.CONTACT_US',
      { name: 'Contact us', link: '/webshop/getAlternateContactUs.do' }
    );

    return (
      <div className={classNames('primary-bar', { logged: isLoggedIn, fbUser: isFbUser && !userAvatarError })}>
        <ol
          id="main-navigation"
          className="nav-common"
        >
          {isLoggedIn
            ? (
              <li className="with-dropdown small-left-pad my-account">
                <PrimaryBarDropdown
                  label={[userAvatarElement, msg.other.tab.myShop]}
                >
                  <NavigationMenuContent
                    ignoreChildren
                    sections={this.buildAccountSection()}
                  />
                </PrimaryBarDropdown>
              </li>
            )
            : null
          }
          <li className="with-dropdown small-left-pad browse-shop">
            <PrimaryBarDropdown
              label="Browse Shop"
              href={catalogueStaticLinks.BROWSE}
            >
              <BrowseShop />
            </PrimaryBarDropdown>
          </li>
          <li>
            <Link className="primaryBar__link" to={links.SHOW_FAVOURITES}>Favourites</Link>
          </li>
          {subscriptionsNavigationEnabled && (
            <li>
              <Link className="primaryBar__link" to="/regulars">
                {msg.subscriptions.navigationName}
              </Link>
            </li>
          )}
          <li>
            <Link className="primaryBar__link" to={catalogueStaticLinks.OFFERS}>Offers</Link>
          </li>
          <li>
            <Link className="primaryBar__link" to={catalogueStaticLinks.NEW}>New</Link>
          </li>
          <li>
            <Link className="primaryBar__link" to="/webshop/displayDeliveryPass.do">Smart Pass</Link>
          </li>
          <li>
            <Link className="primaryBar__link" to="/webshop/getWines.do">Wine</Link>
          </li>
          {seasonalEvents && (
            <li className="with-dropdown seasonal">
              <PrimaryBarDropdown label="Seasonal">
                <SeasonalDropdown seasonalEvents={seasonalEvents} />
              </PrimaryBarDropdown>
            </li>
          )}
          <li className="contact">
            <Link className="primaryBar__link" to={contactUs.link}>{contactUs.name}</Link>
          </li>
        </ol>
      </div>
    );
  }
}
